/**
 * Returns the human-readable role label for a profile, consistent across the app.
 *
 * Profiles with role 'other' are always business-only profiles — there is no
 * separate "Other" category, so they are labelled "Business Owner" to match
 * the formatting of "Mum", "Nanny", "Childminder" etc.
 */
export function getRoleLabel(
  role: string | null | undefined,
  _isBusinessOwner?: boolean | null,
): string {
  if (!role) return '';
  if (role === 'other') return 'Business Owner';
  return role.charAt(0).toUpperCase() + role.slice(1);
}
